import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;
export default function InvitePartner({
  isOpenInviteModal,
  setIsOpenInviteModal,
}) {
  const [email, setEmail] = useState("");

  const handleInvite = async () => {
    if (email === "") return toast.error("Please enter email");

    const endpoint = `${base_url}/${api_type}/partners/invite`;
    try {
      const response = await axios.post(
        endpoint,
        {
          email,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
          },
        }
      );

      toast.success("Invitation sent successfully!");
      setEmail("");
      setIsOpenInviteModal(false);
    } catch (err) {
      toast.error("Failed to send invitation. Please try again.");
      console.error(err);
    } finally {
    }
  };

  return (
    <>
      {isOpenInviteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg w-96 shadow-lg relative">
            <h2 className="text-xl font-semibold mb-4">Invite Partner</h2>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter email address"
              className="w-full px-3 py-2 border rounded mb-4"
              required
            />
            <div className="flex justify-end space-x-2">
              <button
                onClick={() => setIsOpenInviteModal(false)}
                className="px-4 py-2 border rounded hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={handleInvite}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                Send Invite
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
